/* eslint-disable react/prop-types */
import classes from "./card-view-workflow-step.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";

function CardViewWorkflowStep({ step }) {
  return (
    <Flex
      align="stretch"
      direction="column"
      justify="flex-start"
      className={classes.container}
    >
      <Flex
        align="center"
        direction="row"
        justify="flex-start"
        className={classes.title}
      >
        <img src={step?.index} alt="Logo" className={classes.image} />
        <Label weight="bold" tag="h5" color="secondary" align="start">
          {step?.title}
        </Label>
      </Flex>
      <Label align="start" size="md" color="secondary">
        {step?.content}
      </Label>
    </Flex>
  );
}

export default CardViewWorkflowStep;
